export const TENSORFLOW_REGISTRY =
  "registry.gitlab.com/nunet/ml-on-gpu/ml-on-gpu-service/tensorflow_nunet";

export const PYTORCH_REGISTRY =
  "registry.gitlab.com/nunet/ml-on-gpu/ml-on-gpu-service/pytorch_nunet";

export const SERVICE_TYPE = "ml-training-gpu";

// TODO: Change Backend Endpoint fromm here
export const BACKEND_ENDPOINT = "http://localhost:9999/api/v1/run/deploy";
